<template>
    <div class="copybook-result">
        <div class="row-list">
            <div class="item" v-for="row in rows">
                <div class="grid" v-for="item in row" :style="{'width': (936 / number) + 'px'}">
                    <div class="content">
                        {{ item }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        computed: {
            rows() {
                let ret = []
                let rows = this.input.split('\n')
                for (let item of rows) {
                    let row = item.split(/\s+/)
                    if (row.length < this.number) {
                        let num = this.number - row.length
                        while (num--) {
                            row.push('')
                        }
                    }
                    ret.push(row)
                }
                return ret
            }
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        types: '',
                        color: '2',
                        typez: 'zi',
                        blank: '0'
                    }
                }
            },
            input: {
                type: String,
                default: ''
            },
            number: {
                type: Number,
                default: 6
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/var";

    .row-list {
        .item {
            display: flex;
            height: 100px;
            margin-bottom: 16px;
            font-size: 40px;
            line-height: 96px;
            font-weight: 100;
            color: #999;
            background: url("/static/img/pinyin_line.png");
            overflow: hidden;
        }
        .grid {
            // float: left;
            flex-grow: 0;
            flex-shrink: 0;
            width: 156px;
            .content {
                height: 70px;
                // padding-left: 16px;
                margin-top: 15px;
                line-height: 64px;
                text-align: center;
                border-right: 1px solid #999;
            }
            &:first-child {
                .content {
                    border-left: 1px solid #999;
                }
            }
        }
    }
    .copybook-result {
        width: 938px;
        margin: 0 auto;
        padding-left: 2px;
    }
</style>



// WEBPACK FOOTER //
// src/components/pinyin-line/index.vue